import { Button, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import { Image as ImageIcon, List as ListIcon, Info } from "react-feather";

export const MenuOptions = ({ params, Actions }) => {
    const { idcollateral } = params.data;

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
    const handleMenuClose = () => setAnchorEl(null);

    const {
        handleClickFetchInfoCollateral,
        handleClickShowCollateralImages,
    } = Actions;

    const canOpen = Number(idcollateral) > 0;

    return (
        <>
            <Button
                startIcon={<ListIcon />}
                variant="contained"
                size="small"
                color="info"
                onClick={handleMenuOpen}
                sx={{ width: 160 }}
                disabled={!canOpen}
            >
                Ver Detalles
            </Button>

            <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
                {/* VER IMÁGENES */}
                <MenuItem
                    onClick={() => {
                        handleClickShowCollateralImages(idcollateral);
                        handleMenuClose();
                    }}
                >
                    <ListItemIcon>
                        <ImageIcon color="black" size={18} />
                    </ListItemIcon>
                    <ListItemText primary="Detalle imágenes" />
                </MenuItem>

                {/* VER DATOS */}
                <MenuItem
                    onClick={() => {
                        handleClickFetchInfoCollateral(idcollateral, "READONLY");
                        handleMenuClose();
                    }}
                >
                    <ListItemIcon>
                        <Info color="black" size={18} />
                    </ListItemIcon>
                    <ListItemText primary="Detalle datos" />
                </MenuItem>
            </Menu>
        </>
    );
};